import { DISTINCT_VALUE_OBSERVABLE_PRIVATE } from './privates';
import { ObservableEmitAll } from '../../../../core/observable/functions';
export function DistinctValueObservableEmit(instance, value) {
    const privates = instance[DISTINCT_VALUE_OBSERVABLE_PRIVATE];
    if (value !== privates.value) {
        privates.value = value;
        privates.count++;
        ObservableEmitAll(instance, value);
    }
}
//# sourceMappingURL=functions.js.map